import { EnumAPIKey } from "@/constants/app/api";
import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackBlogList } from "./callbacks/callbackBlogList";

export const blogEndpoints = {
  [EnumEndpointsName.BLOG_LIST]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.BLOG_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackBlogList,
  },
  [EnumEndpointsName.BLOG_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.BLOG_DETAIL,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.BLOG_CATEGORY]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.BLOG_CATEGORY,
    api: EnumAPIKey.API_BASE
  },
}